// modules
import { createAction } from 'redux-actions'

export const setCompanyDashboardAlertsPriorityCount = createAction(
  'SET_COMPANY_DASHBOARD_ALERTS_PRIORITY_COUNT'
)

export const setCompanyDashboardData = createAction(
  'SET_COMPANY_DASHBOARD_DATA'
)
export const setCompanyDashboardActivitiesData = createAction(
  'SET_COMPANY_DASHBOARD_ACTIVITIES_DATA'
)
